import EditOutletGroup from "./Edit";

export default function AddOutletGroup() {
    return <EditOutletGroup mode="add" />;
}
